const initialState = {
    token: null,
    error: null,
    isAuthenticated: false,
  };

  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SIGN_UP_SUCCESS':
      case 'SIGN_IN_SUCCESS':
        return { ...state, token: action.payload, error: null };
      case "REFRESH_TOKEN_SUCCESS":
      return {
        ...state,
        token: action.payload, // Update token with the new one
        isAuthenticated: true,
      };
        case 'SIGN_UP_FAILURE':
          case 'SIGN_IN_FAILURE':
              return { ...state, token: null, error: action.payload };
          case 'CLEAR_AUTH_ERROR':
              return { ...state, error: null }; // Clear the error
      case 'SIGN_OUT_SUCCESS':
        sessionStorage.removeItem('token');
        return { ...state, token: action.payload, error: null };
      default:
        return state;
    }
  };

  export default authReducer;